module.exports = __webpack_public_path__ + "img/ico_opt_copy.66b760ce.svg";